export const createSuccessBar = (html) =>{
  const successBar = document.createElement('div');
  successBar.innerHTML = `
    <div>
      ${html}
    </div>
    <div style="display: flex; align-items: center;" id="create-success-bar">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.68654 13.5455L0.454102 12.313L5.76712 7L0.454102 1.68698L1.68654 0.454544L6.99956 5.76756L12.3126 0.454544L13.545 1.68698L8.232 7L13.545 12.313L12.3126 13.5455L6.99956 8.23244L1.68654 13.5455Z" fill="white"/>
      </svg>
    </div>
  `
  successBar.style.cssText = `
    background-color: #21A600;
    color: white;
    position: fixed;
    top: 95px;
    left: 0;
    padding: 8px 16px;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin: 0 16px;
    width: calc(100% - 32px);
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  `;
  console.log(successBar.querySelectorAll('a'));
  successBar.querySelectorAll('a').forEach((a) => {
    a.style.cssText = `
      color: white;
      text-decoration: underline;
    `;
  });
  document.body.appendChild(successBar);
  document.getElementById('create-success-bar').addEventListener('click', () => {
    successBar.remove();
  });
  setTimeout(() => {
    successBar.remove();
  }, 5000);
}

export const createErrorBar = (html) =>{
  const errorBar = document.createElement('div');
  errorBar.innerHTML = `
    <div>
      ${html}
    </div>
    <div style="display: flex; align-items: center;" id="create-error-bar">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.68654 13.5455L0.454102 12.313L5.76712 7L0.454102 1.68698L1.68654 0.454544L6.99956 5.76756L12.3126 0.454544L13.545 1.68698L8.232 7L13.545 12.313L12.3126 13.5455L6.99956 8.23244L1.68654 13.5455Z" fill="white"/>
      </svg>
    </div>
  `
  errorBar.style.cssText = `
    background-color: #F44336;
    color: white;
    position: fixed;
    top: 95px;
    left: 0;
    padding: 8px 16px;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin: 0 16px;
    width: calc(100% - 32px);
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  `;
  document.body.appendChild(errorBar);
  document.getElementById('create-error-bar').addEventListener('click', () => {
    errorBar.remove();
  });
  setTimeout(() => {
    errorBar.remove();
  }, 5000);
}